module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-wrapper"
  }, [_c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Наименование выпуска")]), _vm._v(" "), _c('el-input', {
    staticClass: "fixed-width",
    attrs: {
      "placeholder": "Наименование выпуска"
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.title),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "title", $$v)
      },
      expression: "mutateClaim.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('el-select', {
    staticClass: "fixed-width",
    attrs: {
      "placeholder": "Тип"
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.type),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "type", $$v)
      },
      expression: "mutateClaim.type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Время отображения Выпуска в системе")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "Время отображения на сайте"
    },
    on: {
      "input": _vm.handleUntilRangeChange
    },
    model: {
      value: (_vm.showDateTimeUntil),
      callback: function($$v) {
        _vm.showDateTimeUntil = $$v
      },
      expression: "showDateTimeUntil"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Время начала / окончания сбора заявок")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "Время начала и окончания"
    },
    on: {
      "input": _vm.handleShowRangeChange
    },
    model: {
      value: (_vm.showDateTime),
      callback: function($$v) {
        _vm.showDateTime = $$v
      },
      expression: "showDateTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Время для изменения заявки")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Время для изменения заявки"
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.claimUpdatingDateTime),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "claimUpdatingDateTime", $$v)
      },
      expression: "mutateClaim.claimUpdatingDateTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-label small-width"
  }, [_vm._v("Позволять менять Брокера")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.isBrokerMutable),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "isBrokerMutable", $$v)
      },
      expression: "mutateClaim.isBrokerMutable"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Время сбора подтверждений")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "Время сбора подтверждений"
    },
    on: {
      "input": _vm.handleProposalRangeChange
    },
    model: {
      value: (_vm.proposalDateTime),
      callback: function($$v) {
        _vm.proposalDateTime = $$v
      },
      expression: "proposalDateTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Количество")]), _vm._v(" "), _c('div', [_c('el-input-number', {
    attrs: {
      "controls": false
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.amountMin),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "amountMin", $$v)
      },
      expression: "mutateClaim.amountMin"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls": false
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.amountMax),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "amountMax", $$v)
      },
      expression: "mutateClaim.amountMax"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Предельная сумма")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls": false
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.maxSum),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "maxSum", $$v)
      },
      expression: "mutateClaim.maxSum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-label small-width"
  }, [_vm._v("Кратность")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls": false
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.mult),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "mult", $$v)
      },
      expression: "mutateClaim.mult"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Цена")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mutateClaim.priceMin),
      expression: "mutateClaim.priceMin"
    }],
    staticClass: "float",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mutateClaim.priceMin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mutateClaim, "priceMin", $event.target.value)
      }, _vm.handleChange],
      "keypress": _vm.handleKeyPress
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mutateClaim.priceMax),
      expression: "mutateClaim.priceMax"
    }],
    staticClass: "float",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mutateClaim.priceMax)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mutateClaim, "priceMax", $event.target.value)
      }, _vm.handleChange],
      "keypress": _vm.handleKeyPress
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-label small-width"
  }, [_vm._v("Показывать символ \"%\"")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.showPercent),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "showPercent", $$v)
      },
      expression: "mutateClaim.showPercent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Ставка")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mutateClaim.rateMin),
      expression: "mutateClaim.rateMin"
    }],
    staticClass: "float",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mutateClaim.rateMin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mutateClaim, "rateMin", $event.target.value)
      }, _vm.handleChange],
      "keypress": _vm.handleKeyPress
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mutateClaim.rateMax),
      expression: "mutateClaim.rateMax"
    }],
    staticClass: "float",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mutateClaim.rateMax)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mutateClaim, "rateMax", $event.target.value)
      }, _vm.handleChange],
      "keypress": _vm.handleKeyPress
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-label small-width"
  }, [_vm._v("Аллокация")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.mutateClaim.allocation),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "allocation", $$v)
      },
      expression: "mutateClaim.allocation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Только для квалифиц.")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "name": "qualified"
    },
    on: {
      "input": function($event) {
        return _vm.handleChangeQualifiedTesting('qualified')
      }
    },
    model: {
      value: (_vm.mutateClaim.onlyForQualified),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "onlyForQualified", $$v)
      },
      expression: "mutateClaim.onlyForQualified"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-label small-width"
  }, [_vm._v("Требуется тестирование")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "input": function($event) {
        return _vm.handleChangeQualifiedTesting('testing')
      }
    },
    model: {
      value: (_vm.mutateClaim.testingRequired),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaim, "testingRequired", $$v)
      },
      expression: "mutateClaim.testingRequired"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": _vm.handleRemove
    }
  }, [_c('a', {
    staticClass: "button is-danger"
  }, [_vm._v("-")]), _vm._v("\n    Удалить\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c361493"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Underwriting/Claim.vue
// module id = 893
// module chunks = 0